import type { PrecisionValue } from '@fourthwall/module-analytics'

export const getDateFormat = (precision: PrecisionValue) => {
  return precision === 'HOUR' ? 'MMM D, YYYY h:mm A' : 'MMM D, YYYY'
}
